// Status Tags Colors

export enum BooleanStatus {
  WORKING = 1,
  NOT_WORKING = 2,
  BUSY = 3,
}

export const getStatusDeliveryWorkerColor = (status: BooleanStatus) => {
  switch (status) {
    case BooleanStatus.WORKING:
      return "green";
    case BooleanStatus.BUSY:
      return "orange";
    case BooleanStatus.NOT_WORKING:
      return "red";
    default:
      return "red";
  }
};

// Status Boolean stuts
export const getStatusDeliveryWorker = (status: BooleanStatus) => {
  switch (status) {
    case BooleanStatus.WORKING:
      return "working";
    case BooleanStatus.NOT_WORKING:
      return "not_working";
    case BooleanStatus.BUSY:
      return "busy";
    default:
      return "not_working";
  }
};

export enum StatusDriver {
  ACCEPT = 1,
  PENDING = 2,
  HAND_REJECT = 3,
  NOT_RESPOND = 4,
  CONDITIONS_NOT_MET = 5,
}

export const getStatusDeliveryHistoryColor = (status: StatusDriver) => {
  switch (status) {
    case StatusDriver.ACCEPT:
      return "green";
    case StatusDriver.PENDING:
      return "orange";
    case StatusDriver.HAND_REJECT:
      return "red";
    case StatusDriver.NOT_RESPOND:
      return "blue";
    case StatusDriver.CONDITIONS_NOT_MET:
      return "purple";
    default:
      return "red";
  }
};

// Status Boolean stuts
export const getStatusDeliveryHistoryWorker = (status: StatusDriver) => {
  switch (status) {
    case StatusDriver.ACCEPT:
      return "accept";
    case StatusDriver.PENDING:
      return "pending";
    case StatusDriver.HAND_REJECT:
      return "hand_reject";
    case StatusDriver.NOT_RESPOND:
      return "not_respond";
    case StatusDriver.CONDITIONS_NOT_MET:
      return "conditions_not_met";
  }
};
export const getWorkDay = (day: number) => {
  return weekDays.filter((d) => d.value == day)?.[0]?.label;
};
export const weekDays = [
  { label: "Saturday", value: 1 },
  { label: "Sunday", value: 2 },
  { label: "Monday", value: 3 },
  { label: "Tuesday", value: 4 },
  { label: "Wednesday", value: 5 },
  { label: "Thursday", value: 6 },
  { label: "Friday", value: 7 },
];


export const getWorkDayFromZero = (day: number) => {
  return weekDaysFromZero.filter((d) => d.value == day)?.[0]?.label;
};

export const weekDaysFromZero = [
  { label: "Sunday", value: 0, date: "2025-01-19" },
  { label: "Monday", value: 1, date: "2025-01-20" },
  { label: "Tuesday", value: 2, date: "2025-01-21" },
  { label: "Wednesday", value: 3, date: "2025-01-22" },
  { label: "Thursday", value: 4, date: "2025-01-23" },
  { label: "Friday", value: 5, date: "2025-01-24" },
  { label: "Saturday", value: 6, date: "2025-01-25" },
];
